import { esc } from '../lib/utils.js';

const NAV = [
    { route: '',           label: 'Úvod' },
    { route: 'o-nas',      label: 'O nás' },
    { route: 'aktuality',  label: 'Aktuality' },
    { route: 'obsazeni',   label: 'Obsazení' },
    { route: 'media',      label: 'Média' },
    { route: 'poradatele', label: 'Pro pořadatele' },
    { route: 'anketa',     label: 'Anketa' }
];

export function renderShell(root, { bandName, settings }) {
    const navLinks = NAV.map((n) =>
        `<a class="nav-link" href="#/${n.route}" data-route="${n.route}">${esc(n.label)}</a>`
    ).join('');

    const fb = settings.facebook_url;
    const ig = settings.instagram_url;
    const yt = settings.youtube_url;
    const socials = [
        fb && `<a href="${esc(fb)}" target="_blank" rel="noopener" aria-label="Facebook">Facebook</a>`,
        ig && `<a href="${esc(ig)}" target="_blank" rel="noopener" aria-label="Instagram">Instagram</a>`,
        yt && `<a href="${esc(yt)}" target="_blank" rel="noopener" aria-label="YouTube">YouTube</a>`
    ].filter(Boolean).join('');

    root.innerHTML = `
        <header class="site-header">
            <a class="logo" href="#/">${esc(bandName)}</a>
            <button class="nav-toggle" aria-label="Menu" aria-expanded="false">
                <span></span><span></span><span></span>
            </button>
            <nav class="site-nav">${navLinks}</nav>
        </header>
        <main id="view"><div class="boot">Načítání…</div></main>
        <footer class="site-footer">
            <div class="foot-inner">
                <div class="foot-brand">${esc(bandName)}</div>
                ${socials ? `<div class="foot-social">${socials}</div>` : ''}
                <div class="foot-meta">
                    <span>© ${new Date().getFullYear()} ${esc(bandName)}</span>
                </div>
            </div>
        </footer>
    `;

    // Mobilní menu
    const toggle = root.querySelector('.nav-toggle');
    const nav = root.querySelector('.site-nav');
    toggle.addEventListener('click', () => {
        const open = nav.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
    });
    nav.addEventListener('click', (e) => {
        if (e.target.classList.contains('nav-link')) {
            nav.classList.remove('open');
            toggle.setAttribute('aria-expanded', 'false');
        }
    });
}

export function highlightNav(root, route) {
    root.querySelectorAll('.nav-link').forEach((a) => {
        a.classList.toggle('active', a.dataset.route === route);
    });
}
